import { axiosApi } from "../../../../../api/dbAxios";

export const fetchNotification = async () => {
  try {
    const response = await axiosApi.get(`/notifications/`);
    return response.data;
  } catch (error) {
    console.error("Error fetching notifications:", error);
    return [];
  }
};
